import startCase from 'lodash/startCase';

import {
  PERSON_ACTIVITY_OVERVIEW_SUCCESS,
  PERSON_ACTIVITY_SUCCESS,
} from '../actionConstants';

import { loadUser } from '../utils';

const getActivityOverviewLink = (key, action) => {
  const { buildingId, personId } = action;

  const buildingUrl = `building/${buildingId}`;
  const personUrl = `residents/${personId}`;
  const buildingQuery = `building=${buildingId}`;
  const paginationQuery = `limit=${loadUser()?.defaultPaginationLimit}`;

  switch (key) {
    case 'serviceRequests':
      return `/${buildingUrl}/service-requests?contact_person=${personId}&${buildingQuery}&${paginationQuery}&offset=0&ordering=-updated_at&status=pending`;
    case 'deliveries':
      return `/${buildingUrl}/deliveries/?${paginationQuery}&${buildingQuery}&q&ordering=-created_at&pmc&recipient_related_id=${personId}`;
    case 'visitorsAdded':
      return `/${buildingUrl}/visitors`;
    case 'visitorEntries':
      return `/visitors/log/?${buildingQuery}&${paginationQuery}&offset=0&ordering=-created_at`;
    case 'onlinePaymentsAccessed':
      return `/${buildingUrl}/${personUrl}/activity?action_name=accessed_payments&${paginationQuery}&offset=0&ordering=-created_at`;
    case 'cameraViewings':
      return `/${buildingUrl}/${personUrl}/activity?action_name=view_camera&${paginationQuery}offset=0&ordering=-created_at`;
    case 'intercomCallsReceived':
      return `/${buildingUrl}/${personUrl}/activity?action_name=initiate_resident_call&${paginationQuery}&offset=0&ordering=-created_at`;
    case 'doorOpenings':
      return `/${buildingUrl}/${personUrl}/activity?action_name=open_door&${paginationQuery}&offset=0&ordering=-created_at`;
    case 'assignedAccessCards':
      return null;
    default:
      return '#';
  }
};

const defaultState = {
  activity: {},
  activityOverview: null,
  actionNames: [],
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case PERSON_ACTIVITY_SUCCESS: {
      const data = action?.res?.data;
      const { results, ...rest } = data;
      const activity = results?.actions
        ? { ...rest, results: results?.actions }
        : {};
      const actionNames = results?.['action-names'] ?? [];
      return {
        ...state,
        activity,
        actionNames,
      };
    }
    case PERSON_ACTIVITY_OVERVIEW_SUCCESS: {
      const data = action?.res?.data ?? {};
      const overview = Object.keys(data).map((key) => ({
        action: startCase(key),
        link: getActivityOverviewLink(key, action),
        lastRecords: data[key].last_30_days,
        total: data[key].total,
      }));
      return {
        ...state,
        activityOverview: overview,
      };
    }
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
